import { Trans, useTranslation } from "react-i18next";

const Unauthorised = () => {
    const {t} = useTranslation("locale");
    return (
        <div className="flex flex-column align-items-center justify-content-center">
            <p>
                You are not authorised to access this application. Please <a href="https://www.idwalmarine.com/contact-us" target="_blank">
                    contact us
                </a>.
            </p>
        </div>
    )
}

export default Unauthorised;